module.exports = __webpack_public_path__ + "img/slider-arrow-left-bg-white.80b66dcd.svg";